<template>
  <div>
    <v-list-item
      :disabled="!cuentaSelected"
      @click="onSubmit"
      v-if="$can('transacciones.index')"
    >
      <v-list-item-icon>
        <v-icon>mdi-keyboard-f8</v-icon>
      </v-list-item-icon>
      <v-list-item-title>Imputaciones</v-list-item-title>
      <v-list-item-icon>
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-list-item-icon>
    </v-list-item>
  </div>
</template>
<script>
  import * as XLSX from 'xlsx';
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  export default {
    name: 'ImputacionesExportComponent',
    data () {
      return {
        isFnPressed: false,
      }
    },
    beforeMount () {
      window.addEventListener('keydown', this.handleKeyboard);
    },
    beforeDestroy () {
      window.removeEventListener('keydown', this.handleKeyboard);
    },
    computed: {
      ...mapGetters('ImputacionesExport', ['filters', 'loading']),
      cuenta () {
        return this.$store.getters['Cuentas/selected']
      },
      cuentaSelected () {
        return this.cuenta && this.cuenta.id > 0;
      },
    },
    methods: {
      ...mapActions('ImputacionesExport', ['onSave']),
      ...mapMutations('ImputacionesExport', ['setFilters']),
      handleKeyboard(event) {
        if (event.key === 'F8' && !event.ctrlKey) {
          if (!this.isFnPressed) {
            this.isFnPressed = true;
            
            if (this.cuentaSelected) {
              this.onSubmit(event)
            } else {
              event.preventDefault();
              alert('Primero debe seleccionar una cuenta y un periodo!');
              this.isFnPressed = false;
            }
          }
        }
      },
      async onSubmit (event) {
        event.preventDefault();
        let fechaFrom, fechaTo;
        if(!this.filters.fecha_from || !this.filters.fecha_to) {
          fechaTo = await this.$moment().format('YYYY-MM-DD');
          fechaFrom = await this.$moment(fechaTo).subtract(1, 'years').format('YYYY-MM-DD'); // 90 dias antes de fecha_to
        }
        else {
          fechaTo = await this.filters.fecha_to;
          fechaFrom = await this.filters.fecha_from;
        }
        await this.setFilters({
          ...this.filters,
          fecha_from: fechaFrom,
          fecha_to: fechaTo,
          cuenta_id: this.cuenta.id
        })
        await this.onSave().then(response => {
          const fecha = `${this.cuenta.numero}_${this.filters.fecha_from}_a_${this.filters.fecha_to}`;
          // Crea un nuevo libro de trabajo
          const workbook = XLSX.utils.book_new();
          // Hoja 1: Débitos
          const ws1 = XLSX.utils.json_to_sheet(response.data);
          XLSX.utils.book_append_sheet(workbook, ws1, 'imputaciones');
          // Genera el archivo y lo descarga
          XLSX.writeFile(workbook, `imputaciones-${fecha}.xlsx`);
        });
      }
    },
  }
  </script>
